import React from 'react'
import {Box, Divider, Heading} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import useCustomFetch from '../../hooks/useFetchContent'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {pxToRem} from '../../utills/pxToRem'
import {
    contentStyle,
    giftBalanceStyle,
    headingStyle,
    physicalCardStyle,
    physicalGiftCardWrapper
} from './index.style'
import GiftCardBreadcrumb from './partials/breadcrumb'
import GiftCardBalance from './partials/giftCardBalance/giftCardBalance'
import size from '../../utills/size'
import LoadingSpinner from '../../components/loading-spinner/index'
import {useLocation} from 'react-router-dom'

const GiftCard = () => {
    const {token} = useAccessToken()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const hasCheckBalance = searchParams.has('checkbalance')

    const setBalanceRef = (node) => {
        if (node && hasCheckBalance && balance) {
            const y = node.getBoundingClientRect().top + window.scrollY - 150
            window.scrollTo({top: y, behavior: 'smooth'})
        }
    }

    const {
        response: faq,
        loading: faqLoading,
        error: faqError
    } = useCustomFetch(token, 'ca-gclanding-faq-gc', false)
    const {
        response: physical,
        loading: physicalLoading,
        error: physicalError
    } = useCustomFetch(token, 'ca-gclanding-physical-gc', false)
    const {
        response: egift,
        loading: egiftLoading,
        error: egiftError
    } = useCustomFetch(token, 'ca-gclanding-egift-card', false)
    const {
        response: balance,
        loading: balanceLoading,
        error: balanceError
    } = useCustomFetch(token, 'ca-gclanding-balancecheck-gc', false)

    if (
        (faqLoading || physicalLoading || egiftLoading || balanceLoading) &&
        !(faqError || physicalError || egiftError || balanceError)
    ) {
        return <LoadingSpinner />
    }

    return (
        <Box maxWidth={size.xxl} marginLeft="auto" marginRight="auto">
            <GiftCardBreadcrumb />
            <Box
                marginLeft={[pxToRem(20), pxToRem(20), pxToRem(44.26), pxToRem(44.26)]}
                marginRight={[pxToRem(20), pxToRem(20), pxToRem(44.271), pxToRem(44.271)]}
                marginBottom={[pxToRem(20), pxToRem(20), pxToRem(20), pxToRem(20)]}
            >
                <Heading as="h1" sx={headingStyle}>
                    <FormattedMessage defaultMessage="Cavender's Gift Cards" />
                </Heading>
                <Box
                    data-cid="ca-gclanding-faq-gc"
                    sx={contentStyle}
                    dangerouslySetInnerHTML={{__html: faq}}
                ></Box>
                <Box marginTop={pxToRem(30)} sx={physicalGiftCardWrapper}>
                    <Box
                        data-cid="ca-gclanding-physical-gc"
                        sx={physicalCardStyle}
                        dangerouslySetInnerHTML={{__html: physical}}
                    ></Box>
                    <Box
                        data-cid="ca-gclanding-egift-card"
                        sx={physicalCardStyle}
                        dangerouslySetInnerHTML={{__html: egift}}
                    ></Box>
                </Box>
                <Divider
                    ref={setBalanceRef}
                    marginTop={[pxToRem(40), pxToRem(40), pxToRem(-48), pxToRem(-48)]}
                    marginBottom={[pxToRem(30), pxToRem(30), pxToRem(50), pxToRem(50)]}
                    marginLeft={[pxToRem(11.74), pxToRem(11.74), '0px', '0px']}
                    marginRight={[pxToRem(11.74), pxToRem(11.74), '0px', '0px']}
                    width={['auto', 'auto', 'auto', 'auto']}
                    borderColor="black"
                />
                <Box display={['block', 'block', 'flex', 'flex']}>
                    <Box
                        data-cid="ca-gclanding-balancecheck-gc"
                        sx={giftBalanceStyle}
                        dangerouslySetInnerHTML={{__html: balance}}
                    ></Box>
                    <Box width={['100%', '100%', '40%', '40%']}>
                        <GiftCardBalance />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default GiftCard
